<template>
    <form-row title="Term of Loan">
        <input-text
            class="w-32"
            :value="mortgage.term_of_loan"
            name="term_of_loan"
            placeholder="Term"
            :read_only="read_only"
        />

        <div class="mt-4 sm:mt-0 flex flex-1 items-center text-sm text-gray-warm-800 sm:pl-10">
            Changing this may delay your closing. A pre-payment penalty on your loan may make it expensive to sell your home.
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
